export default __webpack_public_path__ + "static/media/glasses15.94e1c4a5.jpeg";